import React, { useEffect, useState } from "react";
import { Navigate, useAsyncError, useNavigate } from "react-router-dom";
import Axios from './../../../utils/api/axiosConf';
import { url } from './../../../utils/api/api';
import { RedNotif } from "../../../utils/utils";
import TABLE from './../../../components/table/table'
import { FarsiDate } from "../../../utils/utils"
import avatar from './../../../../src/assets/images/avatar.jpg'
import { color } from "../../../utils/themes/color";
import RADIO from "../../../components/radio/radio";
import "./userList.css"

export default function UserList() {
    const [data, setData] = useState();
    const [page, setPage] = useState({ current: 1, total: 1, pageSize: 5 });
    const [loading, setLoading] = useState(null);
    const [filter, setFilter] = useState("all");
    const navigate = useNavigate();
    const columns = [
        {
            title: 'پروفایل',
            dataIndex: 'profile',
            render: (profile) => profile != undefined ?
                profile.fileName != null ?
                    <img className="tableImage" crossOrigin="anonymous" src={`${url}${profile.path}`} />
                    : <img className="tableImage" src={avatar} />
                : <img className="tableImage" src={avatar} />,
            key: '_id',
        },
        {
            title: 'نام کامل',
            render: (e) =>
                e.fullName != undefined && e.fullName != '' && e.fullName != null
                    ? <p style={{ color: color.primary, cursor: 'pointer' }}
                        onClick={() => e.role == "athlete" ? navigate(`/athlete?id=${e._id}`) : navigate(`/coach?id=${e._id}`)}
                    > {e.fullName}</p >
                    :
                    <p style={{ color: color.primary, cursor: 'pointer' }}
                        onClick={() => e.role == "athlete" ? navigate(`/athlete?id=${e._id}`) : navigate(`/coach?id=${e._id}`)}
                    >............</p >
            , key: '_id',
        },
        {
            title: 'تاریخ ثبت نام',
            dataIndex: 'insertDate',
            render: (insertDate) => <p>{FarsiDate(insertDate)}</p>,
            key: '_id',
        },
        {
            title: 'موبایل',
            dataIndex: 'mobile',
            key: '_id',
        },
        {
            title: 'نوع کاربری',
            dataIndex: 'role',
            render: (role) => <p>{Role(role)}</p>,
            key: '_id',
        },
    ];

    const filters = [{ "name": "همه", "value": "all" }, { "name": "ورزشکار", "value": "athlete" }, { "name": "مربی", "value": "coach" }];



    const Role = (R) => {
        switch (R) {
            case "athlete": return "ورزشکار"
            case "coach": return "مربی"
        }
    }

    useEffect(() => {
        setLoading(true)
        if (filter == "all") {
            Axios.get(`${url}users/search?limit=5&pageNumber=${page.current}`)
                .then((response) => {
                    if (response.status === 200 || response.status === 201) {
                        setData(response.data.docs)
                        setPage({
                            ...page,
                            current: response.data.page,
                            total: response.data.totalDocs

                        })
                        setLoading(false)
                     }
                    else {
                        RedNotif(response.message)
                    }
                })
                .catch((error) => {
                    RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
                });
        } else {
            Axios.get(`${url}users/search?limit=5&pageNumber=${page.current}&role=${filter}`)
                .then((response) => {
                    if (response.status === 200 || response.status === 201) {
                        setData(response.data.docs)
                        setPage({
                            ...page,
                            current: response.data.page,
                            total: response.data.totalDocs

                        })
                        setLoading(false)
                    }
                    else {
                        RedNotif(response.message)
                    }
                })
                .catch((error) => {
                    RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
                });
        }
    }, [page.current, filter])

    const pager = (p) => {
        if (p != undefined) {
            setPage({ ...page, current: p })
        }
        return page;
    }

    return (
        <>
            <div className="filterUser" style={{ background: color.primary }}>
                <p style={{ float: 'right',  color: color.textColor }} >فیلتر کاربران</p>
                <div style={{ float: "left" }}>
                    <RADIO click={(e) => { setFilter(e); setPage({ ...page, current: 1 }) }} items={filters} defaultValue={"all"} />
                </div>
            </div>
            <TABLE
                data={data}
                columns={columns}
                page={pager}
                loading={loading} />
        </>
    )


}